RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.ContactUsModal = Marionette.ItemView.extend({

        ui: {
            modal: '.modal',
            modalDescription: '.modal-description',
            contactMethod: 'input:radio',
            formContent: '.x-form',
            confirmationContent: '.x-confirmation',
            formGroupPhoneNumber: '#formGroupPhoneNumber',
            formGroupEmail: '#formGroupEmail',
            inputPhoneNumber: '#inputPhoneNumber',
            inputEmail: '#inputEmail',
            cancelButton: '.x-cancel',
            contactMeButton: '.x-contact-me',
            closeButton: '.x-close'
        },

        events: {
            'shown.bs.modal': 'onModalShown',
            'keypress input': 'onKeypress',
            'change @ui.contactMethod': 'onContactMethodChange',
            'click @ui.contactMeButton': 'onSubmit',
            'click @ui.closeButton': 'onClose'
        },

        template: '#contactUsModalTemplate',

        templateHelpers: function () {
            const me = this;

            return {
                phone_number: RivalIQ.state.user.get('phone_number'),
                email: RivalIQ.state.user.get('email'),
                description: me.model.get('modalDescription'),
                productName: RivalIQ.state.plan.get('has_quid_compete_branding') ? 'Quid Compete' : 'Rival IQ'
            };
        },

        onRender: function () {

            const me = this;
            me.ui.modal.modal();
        },

        onModalShown: function () {

            const me = this;

            me.contactMethod = 'phone';
            me.configureFormBasedOnContactMethod();

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ViewedContactUsModal, {
                context: me.model.get('context')
            });
        },

        configureFormBasedOnContactMethod: function () {

            const me = this;

            if (me.contactMethod === 'phone') {

                me.ui.formGroupEmail.hide();
                me.ui.formGroupPhoneNumber.show();
                me.ui.inputPhoneNumber.select();
            } else {

                me.ui.formGroupPhoneNumber.hide();
                me.ui.formGroupEmail.show();
                me.ui.inputEmail.select();
            }
        },

        onContactMethodChange: function (e) {

            const me = this;

            me.contactMethod = $(e.target).val();
            me.configureFormBasedOnContactMethod();
        },

        onKeypress: function (e) {

            const me = this;
            if (e.which === 13) {
                me.onSubmit(e);
            }
        },

        onSubmit: function (e) {

            const me = this;

            e.preventDefault();

            let hasError = false;
            let contactDetails = '';

            if (me.contactMethod === 'phone') {

                contactDetails = me.ui.inputPhoneNumber.val();
                hasError = contactDetails.match(/^\s*$/);
                if (hasError) {
                    me.ui.inputPhoneNumber.closest('.form-group').addClass('has-error');
                } else {
                    me.ui.inputPhoneNumber.closest('.form-group').removeClass('has-error');
                }

            } else {

                contactDetails = me.ui.inputEmail.val();
                hasError = contactDetails.match(/^\s*$/);
                if (hasError) {
                    me.ui.inputEmail.closest('.form-group').addClass('has-error');
                } else {
                    me.ui.inputEmail.closest('.form-group').removeClass('has-error');
                }
            }

            if (!hasError) {

                const promise = $.ajax({
                    type: 'POST',
                    url: '/api/requestContact',
                    dataType: 'json',
                    data: {
                        contactMethod: me.contactMethod,
                        contactDetails: contactDetails,
                        context: me.model.get('context')
                    }
                });

                RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.SubmittedContactUsModal, {
                    context: me.model.get('context')
                });

                promise.done(function () {
                    me.ui.modalDescription.hide();
                    me.ui.formContent.hide();
                    me.ui.confirmationContent.show();
                    me.ui.cancelButton.hide();
                    me.ui.contactMeButton.hide();
                    me.ui.closeButton.show();
                });

                promise.fail(function () {
                    me.ui.contactMeButton.button('reset');
                    RivalIQ.execute('alert:danger', 'An error occurred, please try again');
                });

            }
        },

        onClose: function (e) {

            const me = this;
            e.preventDefault();
            me.ui.modal.modal('hide');
        }

    });

});
